import React from 'react'
import PropTypes from 'prop-types'
import { AutoComplete as AntdAutoComplete } from 'antd'

export default class AutoComplete extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filteredDataSource: [],
    }

    this.onSearch = (value, dataSource) => {
      const filteredDataSource = dataSource.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      )

      this.setState({
        filteredDataSource,
        selection: value,
      })
    }

    this.formatDataSource = (objectDataSource, filterParam) => {
      let formattedDataSource
      if (objectDataSource[0].dataType) {
        formattedDataSource = objectDataSource
          .filter((obj) => obj.dataType === 'Uint16')
          .map((obj) => obj[filterParam])
      } else {
        formattedDataSource = objectDataSource.map((obj) => obj[filterParam])
      }
      return formattedDataSource
    }

    this.onSelect = (value, dataSource, filterParam, callbackFn) => {
      this.setState({ selection: value })
      if (typeof dataSource[0] === 'object') {
        value = dataSource.find((obj) => obj[filterParam] === value)
      } else {
        value = dataSource.find((k) => k === value)
      }
      callbackFn(value)
    }
  }

  componentDidMount() {
    this.setState({
      selection: this.props.value || this.props.defaultValue || null,
    })
  }

  render() {
    const formattedDataSource = this.props.objectDataSource
      ? this.formatDataSource(
          this.props.objectDataSource,
          this.props.filterParam
        )
      : this.props.dataSource

    return (
      <AntdAutoComplete
        defaultValue={this.props.defaultValue}
        value={this.state.selection}
        dataSource={this.state.filteredDataSource}
        onSelect={(value) => {
          this.onSelect(
            value,
            this.props.objectDataSource
              ? this.props.objectDataSource
              : this.props.dataSource,
            this.props.filterParam,
            this.props.onSelect
          )
        }}
        onSearch={(value) => this.onSearch(value, formattedDataSource)}
        placeholder={'Available'}
      />
    )
  }
}

AutoComplete.propTypes = {
  dataSource: PropTypes.array,
  defaultValue: PropTypes.string,
  objectDataSource: PropTypes.arrayOf(Object),
  filterParam: PropTypes.string,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.string,
}
